export { default } from './Icon';
export type { IconComponent, IconProps } from './Icon';
export type { default as IconColor } from './IconColor';
